import { AIRPORTS_IDS } from './constants'

export enum Island {
  GC = 'GC',
  TNF = 'TNF',
  LP = 'LP',
  FTV = 'FTV',
  LNZ = 'LNZ',
  LG = 'LG',
  EH = 'EH'
}

export enum CardinalPoint {
  NORTH = 'NORTH',
  SOUTH = 'SOUTH',
  EAST = 'EAST',
  WEST = 'WEST'
}

type Coordinates = [number, number]

export const ISLAND_ZONE_POLYGONS: { [key in Island]: Coordinates[] } = {
  GC: [
    [-15.54764784528382, 28.243044402318034],
    [-15.788819240097865, 28.215948810847365],
    [-15.95229783658337, 27.92173498969356],
    [-15.669042842673406, 27.62958641144938],
    [-15.306476450468807, 27.767165824081474],
    [-15.287053250886458, 28.19883226216855],
    [-15.54764784528382, 28.243044402318034]
  ],
  TNF: [
    [-16.727127234800776, 28.536662159810973],
    [-17.036279828153596, 28.412879181511457],
    [-16.84852223219039, 28.032090903509697],
    [-16.64619723654107, 27.850491586281976],
    [-16.30305404391882, 28.159171171936137],
    [-15.912971452305356, 28.512486086679488],
    [-16.150905647190115, 28.71283732944444],
    [-16.727127234800776, 28.536662159810973]
  ],
  FTV: [
    [-13.910123633296507, 28.820087216389723],
    [-14.081695229607647, 28.76476599207554],
    [-14.261359825744336, 28.355334163559434],
    [-14.656298217253209, 28.070073004752345],
    [-14.384373423100016, 27.977199373193343],
    [-13.832430834967056, 28.16001243954915],
    [-13.689994038029027, 28.800231693105502],
    [-13.910123633296507, 28.820087216389723]
  ],
  LNZ: [
    [-13.899551200404971, 28.836633252525687],
    [-13.685896004998853, 28.81678088395182],
    [-13.318473812898901, 29.063248132902956],
    [-13.357320212063655, 29.482582566618106],
    [-13.72312380419848, 29.479764527586084],
    [-13.952964999256693, 28.917421643187936],
    [-13.899551200404971, 28.836633252525687]
  ],
  LP: [
    [-17.865361159927545, 28.961923852129758],
    [-18.14931590097612, 28.80629271383816],
    [-17.906545435347084, 28.34182127734431],
    [-17.66160737627507, 28.389504724768727],
    [-17.62692588118574, 28.87085099684063],
    [-17.865361159927545, 28.961923852129758]
  ],
  LG: [
    [-17.262079361797518, 28.227865077190135],
    [-17.34990499728336, 28.16157714222823],
    [-17.35510157691461, 28.103275571633898],
    [-17.283215558682333, 28.029398405646134],
    [-17.238755932948315, 28.0186947449708],
    [-17.143196607507015, 28.049528597470555],
    [-17.105665754614662, 28.07908002553236],
    [-17.090076015720914, 28.102002257814398],
    [-17.117791107087577, 28.155977495510623],
    [-17.180150062662563, 28.194151093078403]
  ],
  EH: [
    [-18.131209468371466, 27.775835890628894],
    [-18.162283496343008, 27.739744552564748],
    [-18.144804355609015, 27.699342446767552],
    [-18.062263968809614, 27.69074432312998],
    [-18.007398888172364, 27.645162965343065],
    [-17.962244441276223, 27.636130440547866],
    [-17.92971381824352, 27.72384338259779],
    [-17.870478952422772, 27.809768012253045],
    [-17.934569135114074, 27.8557098117787],
    [-17.99817378611832, 27.825656628700038],
    [-18.08022864123066, 27.757791717233015]
  ]
}

export const ISLANDS_AIRPORTS_POLYGONS: Partial<{ [key in Island]: Partial<{ [key in CardinalPoint]: Coordinates[] }> }> = {
  TNF: {
    NORTH: [
      [-16.346963350327115, 28.48920810401961],
      [-16.35518013991134, 28.48959122235094],
      [-16.3589942995321, 28.48903570031652],
      [-16.359648155467312, 28.48623888981072],
      [-16.32430607542966, 28.474688696524353],
      [-16.32163085665968, 28.47662528371903],
      [-16.322984202625605, 28.47944710435536],
      [-16.32886968391685, 28.481521924373297],
      [-16.338091320379448, 28.484371277434462],
      [-16.335636413745334, 28.49006975289717],
      [-16.346963350327115, 28.48920810401961]
    ],
    SOUTH: [
      [-16.600867469929653, 28.050925090594546],
      [-16.595151090102604, 28.03390276886644],
      [-16.585507805872254, 28.033200759626524],
      [-16.55041420449814, 28.046406541026542],
      [-16.549768005039994, 28.056101447996767],
      [-16.559510704571466, 28.059259780930702],
      [-16.577355751162287, 28.06149687728059],
      [-16.586004882378717, 28.058426340975103],
      [-16.586999035392665, 28.055048649732456],
      [-16.600867469929653, 28.050925090594546]
    ]
  },
  GC: {
    NORTH: [
      [-15.392591164537407, 27.94268158949643],
      [-15.39938903436402, 27.916147225152358],
      [-15.386584959045052, 27.90986306574068],
      [-15.370820588666305, 27.94279979300316],
      [-15.381551006307973, 27.948380322934895],
      [-15.392591164537407, 27.94268158949643]
    ]
  },
  LP: {
    NORTH: [
      [-17.75984806598592, 28.63911980049727],
      [-17.759621062926954, 28.616015087465172],
      [-17.74802906615767, 28.61522577592733],
      [-17.75084845487646, 28.638934057957954],
      [-17.75984806598592, 28.63911980049727]
    ]
  },
  FTV: {
    NORTH: [
      [-13.876641609553246, 28.465509622495787],
      [-13.883374809494711, 28.429022611301377],
      [-13.851373532872685, 28.428303785517414],
      [-13.855767510454882, 28.467517367430517],
      [-13.876641609553246, 28.465509622495787]
    ]
  },
  LNZ: {
    NORTH: [
      [-13.612283594652041, 28.93434444532224],
      [-13.599590338122994, 28.934167553185958],
      [-13.596801055637826, 28.95769155679369],
      [-13.61260698972302, 28.95755007499774],
      [-13.618994042370815, 28.946513899353263],
      [-13.616891974410919, 28.93632561662689],
      [-13.612283594652041, 28.93434444532224]
    ]
  },
  LG: {
    NORTH: [
      [-17.222394888605777, 28.03300616427248],
      [-17.224697543868075, 28.02615057766151],
      [-17.204815995700983, 28.02696128770576],
      [-17.20627432776044, 28.0344398260293],
      [-17.222394888605777, 28.03300616427248]
    ]
  },
  EH: {
    NORTH: [
      [-17.892347418538094, 27.821021918732427],
      [-17.88667036108285, 27.807052393028982],
      [-17.881465533680768, 27.809468648074613],
      [-17.888246939210774, 27.82236747774185],
      [-17.892347418538094, 27.821021918732427]
    ]
  }
}

function reversePointsOrder(points: Coordinates[]) {
  return points.map((point) => [point[1], point[0]])
}

export function isPointInPolygon(point: Coordinates, vs: Coordinates[]) {
  // This is made because the polygons are defined with [lat, lng] and the point is defined with [lng, lat]
  const vsReverse = reversePointsOrder(vs)

  const [x, y] = point

  let inside = false
  for (let i = 0, j = vsReverse.length - 1; i < vsReverse.length; j = i++) {
    const [xi, yi] = vsReverse[i]
    const [xj, yj] = vsReverse[j]

    const intersect = yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
    if (intersect) inside = !inside
  }

  return inside
}

export function calculateIslandFromCoordinates(coordinates: Coordinates): Island {
  for (const [island, polygons] of Object.entries(ISLAND_ZONE_POLYGONS)) {
    if (isPointInPolygon(coordinates, polygons)) {
      return island as Island
    }
  }
  return Island.GC
}

export function areInSameIsland(startLatitude: number, startLongitude: number, endLatitude: number, endLongitude: number) {
  const start = [startLatitude, startLongitude] as Coordinates
  const end = [endLatitude, endLongitude] as Coordinates

  const startIsland = calculateIslandFromCoordinates(start)
  const endIsland = calculateIslandFromCoordinates(end)

  return startIsland === endIsland
}

export function getAirportPlaceIdByCoordinates(placeCoords: Coordinates) {
  for (const island of Object.values(Island)) {
    const airportPolygons = ISLANDS_AIRPORTS_POLYGONS[island]
    if (airportPolygons) {
      for (const cardinalPoint of Object.values(CardinalPoint)) {
        const airportPolygon = airportPolygons[cardinalPoint]
        if (airportPolygon && isPointInPolygon(placeCoords, airportPolygon)) {
          switch (island) {
            case Island.GC:
              return AIRPORTS_IDS.LPA
            case Island.FTV:
              return AIRPORTS_IDS.FUE
            case Island.LNZ:
              return AIRPORTS_IDS.ACE
            case Island.LP:
              return AIRPORTS_IDS.SPC
            case Island.LG:
              return AIRPORTS_IDS.GMZ
            case Island.EH:
              return AIRPORTS_IDS.VDE
            case Island.TNF:
              return cardinalPoint === CardinalPoint.NORTH ? AIRPORTS_IDS.TFN : AIRPORTS_IDS.TFS
          }
        }
      }
    }
  }

  return undefined
}
